import type { BaseGameCommunicationMessageType } from '../../services/gameCommunication/types';

export interface GameCommunicationErrorMessageType extends GameCommunicationMessageType {
  optExtErrorCode?: string;
  optExtErrorMsg?: string;
  category?: string;
  severity?: string;
}

export type GameCommunicationMessageType = BaseGameCommunicationMessageType;

export interface ExtractedMessageType {
  amount: number;
  betCode: number;
  bettype: string;
  nc: number;
}

export type AcceptanceState = 'unknown' | 'accepted' | 'not_accepted' | 'rejected';

export const MessageName = {
  Bet: 'bet',
  BetValidationError: 'betValidationError',
  BetsClosed: 'betsclosed',
  BetsClosingSoon: 'betsclosingsoon',
  BetsOpen: 'betsopen',
  Bets: 'bets',
  Canceled: 'canceled',
  Command: 'command',
  Dealer: 'dealer',
  DuplicatedConnection: 'duplicated_connection',
  EnableSubmit: 'enableSubmit',
  GameInit: 'gameInit',
  Game: 'game',
  Message: 'message',
  PrizedropWin: 'prizedrop_win',
  BonusCardPromoWin: 'bonuscard_win',
  RegulationError: 'regulationError',
  StartDealing: 'startDealing',
  Subscribe: 'subscribe',
  Switch: 'switch',
  TableCloseNotify: 'tableCloseNotify',
  TableClosed: 'table_closed',
  Table: 'table',
  ThirdPartyError: 'thirdpartyerror',
  Timer: 'timer',
  Win: 'win',
  Winners: 'winners',
  Session: 'session',
  Pong: 'pong',
  DuplicatePrivatePlayerSession: 'duplicatPrivatePlayerSession', // new private tables duplicate player msg
  Kickedout: 'kickedout',
  IdleAlert: 'idleAlert',
  PlayerError: 'player_error',
  PlayerBanned: 'PlayerBanned',
  PrivateBCGameStatus: 'privateBCGameStatus',
  TableOccupied: 'table_occupied',
  FreeChipsAvailable: 'freeChipsAvailable',
  TerminateSession: 'terminateSession',
  ToasterMessage: 'toasterMessage',
} as const;

/** Special cases. Other than that, show generic error popup */
export enum BetValidationErrors {
  BetCodeError = 1028,
  BetCodeInvalid = 1011,
  BetInvalid = 10002, // ck, gamemode
  BetNotAllowed = 20602,
  BetNotExist = 10005,
  BetNotOnTime = 1007,
  BetRefunded = 20620,
  DidntMeetMaximumTableLimit = 1012,
  DidntMeetMinimumTableLimit = 1013,
  DidntMeetMinimumBetLimit = 1049,
  MaximumBetLimitExceeded = 1048,
  FreeChipUnknownError = 5000,
  FreeChipCampaignError = 5001,
  MainBetNotAvailable = 1041,
  ExternalIgnoreError = 20530,
  ExternalRetryError = 20621,
  GameIdMismatch = 1014,
  GameNotFound = 20038,
  InstantBetsDisabled = 1055,
  InsufficientBalance = 20601,
  InternalServerError = 20003,
  InvalidHashCode = 20999, // operator specific
  InvalidToken = 20510,
  NoResponse = 1001,
  OperatorInternalError = 101020,
  PlayerLimitReached = 20610,
  PlayerNotFound = 20511,
  RealityCheck = 20520,
  RequestError = 1046,
  RequestNoResponse = 1047,
  RequestTimeout = 1050,
  PlayerBonusBetWithoutMainBet = 1059,
  BankerBonusBetWithoutMainBet = 1060,
  UnknownError = 0,
}
